import React from "react";
import {
	Box,
	Card,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Typography,
} from "@mui/material";
import EventAvailableTwoToneIcon from "@mui/icons-material/EventAvailableTwoTone";
import type { ISessionEnroll } from "src/Types/module/b2bSession/b2bSessionEnroll.types";
import SessionEnrollTableRow from "../../B2BSession/SessionEnroll/SessionEnrollTableRow";

interface Props {
	sessions?: ISessionEnroll[];
}

const B2BSingleSessionsTable: React.FC<Props> = ({ sessions = [] }) => {
	if (!sessions || sessions.length === 0) {
		return (
			<Card
				elevation={0}
				sx={{
					p: 3,
					my: 1,
					textAlign: "center",
					bgcolor: "background.paper",
					border: "1px dashed",
					borderColor: "divider",
					borderRadius: 1.5,
				}}
			>
				<Box
					display="flex"
					flexDirection="column"
					alignItems="center"
					justifyContent="center"
					gap={0.5}
				>
					<EventAvailableTwoToneIcon
						sx={{ fontSize: 38, color: "text.secondary", opacity: 0.6 }}
					/>
					<Typography variant="h5" fontWeight={600} color="text.secondary">
						No Enrolled Sessions Found
					</Typography>
					<Typography variant="caption" color="text.disabled">
						This B2B member does not have any enrolled sessions yet.
					</Typography>
				</Box>
			</Card>
		);
	}

	return (
		<Box sx={{ mt: 1 }}>
			<TableContainer
				component={Card}
				elevation={0}
				sx={{
					border: "1px solid",
					borderColor: "divider",
					borderRadius: 1.5,
					overflow: "hidden",
				}}
			>
				<Table size="small">
					<TableHead sx={{ bgcolor: "grey.50" }}>
						<TableRow>
							<TableCell sx={{ fontWeight: 700, py: 1 }}>SL.</TableCell>
							<TableCell sx={{ fontWeight: 700, py: 1 }}>Session Slot</TableCell>
							<TableCell sx={{ fontWeight: 700, py: 1 }}>Invoice Details</TableCell>
							<TableCell sx={{ fontWeight: 700, py: 1 }}>Status</TableCell>
							<TableCell sx={{ fontWeight: 700, py: 1 }}>Created Date</TableCell>
							<TableCell align="right" sx={{ fontWeight: 700, py: 1 }}>
								Action
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{sessions.map((enroll, index) => (
							<SessionEnrollTableRow
								key={enroll.id || index}
								enroll={enroll}
								serial={index + 1}
								hideMember
							/>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		</Box>
	);
};

export default B2BSingleSessionsTable;
